import React from 'react';
import { usePriceRowContext } from '../../../price-row-context';
import RatingSmiley from 'src/components/rating/smiley-rating';
import { ViewSize } from '../../types';
import { RatingContainer } from './styles';

export const StoreRatingAverage: React.FC = () => {
  const { isFeatured = false, offer, viewSize } = usePriceRowContext();
  const { store, rating } = offer;

  if (!store || !rating || rating.whole <= 0) {
    return null;
  }

  return (
    <RatingContainer data-rating={rating.roundedString}>
      <RatingSmiley
        featured={isFeatured}
        rating={rating}
        scoreVisibility="row"
        size="small"
        reviewCount={
          viewSize >= ViewSize.MEDIUM
            ? store.userReviewSummary.countTotal
            : undefined
        }
      />
    </RatingContainer>
  );
};
